import { render, staticRenderFns } from "./penaltyLedger.vue?vue&type=template&id=548ebaaa&scoped=true"
import script from "./penaltyLedger.vue?vue&type=script&lang=js"
export * from "./penaltyLedger.vue?vue&type=script&lang=js"
import style0 from "./penaltyLedger.vue?vue&type=style&index=0&id=548ebaaa&prod&lang=scss&scoped=true"
import style1 from "./penaltyLedger.vue?vue&type=style&index=1&id=548ebaaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ebaaa",
  null
  
)

export default component.exports